'use client';

import cn from 'classnames';

import { Wrapper } from '@/components/Wrapper';
import { useWindowWidth } from '@/hooks/useWindowWidth';

import { CarouselBase } from '../../CarouselBase';
import { PeopleSlide } from '../../CarouselBase/slides/PeopleSlide';
import s from './PeopleCarousel.module.scss';

interface SlideProps {
  image?: string;
  link?: string;
  badge?: {
    name: string;
    position: string;
  };
  title?: string;
  description: string;
}

interface PeopleCarouselProps {
  slides: SlideProps[];
}

const PeopleCarousel = ({ slides }: PeopleCarouselProps) => {
  const {
    windowWidth,
    breakpoints: { MD },
  } = useWindowWidth();

  return (
    <section className={cn(s.root)}>
      <Wrapper>
        <div className={s.subtitle}>мнения людей</div>
        <h2 className={s.title}>Люди Cloud.ru о работе в компании</h2>
      </Wrapper>
      <div className={s.carouselWrapper}>
        <CarouselBase
          slidesCount={slides.length}
          withNavigation={!!windowWidth && windowWidth >= MD}
          withPagination={!!windowWidth && windowWidth <= MD}
          carouselClassName={s.carousel}
          rewind
          navigationClassName={s.navigation}
          slideClassName={s.slide}
          analyticsName="people-carousel"
          breakpoints={{
            0: {
              slidesPerView: 1.1,
            },
            637: {
              slidesPerView: 1.9,
            },
            829: {
              slidesPerView: 3.0,
            },
            1053: {
              slidesPerView: 3.1,
            },
          }}
        >
          {slides.map(({ title, badge, image, link, description }, index) => {
            return (
              <PeopleSlide
                title={title}
                badge={badge}
                image={image}
                link={link}
                description={description}
                key={index}
                className={cn(s.slideInner)}
              />
            );
          })}
        </CarouselBase>
      </div>
    </section>
  );
};

export { PeopleCarousel };
